import { useEffect, useState } from "react";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {
  FaShareAlt,
  FaCopy,
  FaEdit,
  FaTrash,
  FaUpload,
  FaVideo,
  FaRupeeSign,
  FaUser,
  FaWhatsapp,
  FaEye,
  FaStar,
  FaHome,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaBuilding,
  FaDownload,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaWifi,
  FaParking,
  FaSwimmingPool,
  FaDumbbell,
  FaLightbulb,
  FaTree,
  FaUsers,
  FaChild,
  FaHeadset,
  FaImage,
  FaCar,
  FaFireExtinguisher,
  FaStore,
  FaMosque,
  FaUserShield,
  FaFile
} from "react-icons/fa";
import { IoIosMail } from "react-icons/io";
import { Button, Card, Modal, Form, Container, Row, Col, Dropdown } from "react-bootstrap";
import Const from "../../util/Constants";
import { reactLocalStorage } from "reactjs-localstorage";
import PropertyAPI from "../../api/PropertyAPI";
import Util from "../../util/Util";
import Display from "../../util/Display";
import DocumentAPI from "../../api/DocumentAPI";
import ContactAPI from "../../api/ContactAPI";
import { NavLink } from "react-router-dom";
import DocumentPopup from "../meeting/DocumentPopup";
import WhatsAppPopup from "../whatsapp/WhatsAppPopup";
import PropertyContactPopup from "../contact/PropertyContactPopup";
import LeadAPI from "../../api/LeadAPI";
import LeadConst from '../../util/LeadConst';
import FieldState from "../common/FieldState";
import FieldCity from '../common/FieldCity';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});
const amenityIconMap = {
  'car parking': FaCar,
  'cctv': FaVideo,
  'club': FaUsers,
  'children play area': FaChild,
  'fire safety': FaFireExtinguisher,
  'gym': FaDumbbell,
  'intercom': FaHeadset,
  'internet provider': FaWifi,
  'lift': FaBuilding,
  'park': FaTree,
  'power backup': FaLightbulb,
  'security': FaUserShield,
  'shopping center': FaStore,
  'swimming': FaSwimmingPool,
  'temple': FaMosque,
  'visitors parking': FaParking,
};

const Amenities = (nwPropertyData, model) => {
  // Get and normalize amenity strings
  const amenitiesRaw = Display.FieldValue(nwPropertyData, 'amenities', model.fields);
  const amenities = amenitiesRaw?.split(',').map(a => a.trim()).filter(Boolean);

  // Filter and map to amenities with icons
  const displayAmenities = amenities
    .map(name => {
      const key = name.toLowerCase();
      const Icon = amenityIconMap[key];
      if (!Icon) return null;
      return { name, Icon };
    })
    .filter(Boolean); // Remove unmatched

  return displayAmenities.map((amenity, idx) => (
    <Col xs={6} sm={4} md={3} lg={2} key={idx} className="mb-3">
      <div className="d-flex align-items-center small text-secondary">
        <amenity.Icon size={18} className="text-muted mr-2" />
        <span style={{ fontSize: "12px", fontWeight: "500" }}>{amenity.name}</span>
      </div>
    </Col>
  ));
};

export const fetchRelatedProperties = async (matchingPropertyData, model) => {
  return await Promise.all(
    (matchingPropertyData || []).map(async (property) => {
      const featuredImage = property?.featured_image
        ? await DocumentAPI.getPublicMediaUrl(
          property.featured_image?.split(Const.Opt).filter(Boolean)
        )
        : null;

      return {
        id: property.id,
        name: property.name,
        image:
          featuredImage?.url ||
          "/images/dummyProperty.jpg",
        price: property.price,
        configuration: Display.FieldValue(property, "property_type", model.fields),
        type: Display.FieldValue(property, "type", model.fields),
      };
    })
  );
};


const RelatedPropertiesList = ({ matchingPropertyData, nwPropertyData, model, navigate }) => {
  const [properties, setProperties] = useState([]);

  useEffect(() => {
    const loadData = async () => {
      const filtered = matchingPropertyData?.filter((data) => data?.id !== nwPropertyData?.id);
      const result = await fetchRelatedProperties(filtered, model);
      setProperties(result);
    };

    loadData();
  }, [matchingPropertyData, model]);
  return (
    <>
      {
        properties.map((property) => (
          <Card
            key={property.id}
            style={{ minWidth: "200px", maxWidth: "200px" }}
            className="shadow-sm"
          >
            <Card.Body className="p-0">
              <img
                src={property.image}
                alt={property.name}
                className="w-100 object-fit-contain rounded-top"
                style={{ height: "150px" }}
              />
              <div className="p-3">
                <h4
                  className="font-weight-semibold small mb-1 text-primary cursor-pointer"
                  onClick={() => navigate("/property/preview/" + property.id)}
                >
                  {property.name}
                </h4>
                <p className="small text-secondary mb-1">{property.configuration}</p>
                <p className="small font-weight-bold text-dark">
                  ₹{Number.parseInt(property.price).toLocaleString()}
                </p>
              </div>
            </Card.Body>
          </Card>
        ))
      }
    </>
  );
};

const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "0.5rem",
};

const googleMapsApiKey = "AIzaSyBIqXz1A8OhSJuDvAhRNpbjIwfVyNvfFsU";
const loadGoogleMaps = () => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve();
      return;
    }

    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) {
      existingScript.onload = resolve;
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-maps-script';
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBIqXz1A8OhSJuDvAhRNpbjIwfVyNvfFsU&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;

    document.head.appendChild(script);
  });
};

const PropertyPreviewDesign2 = (props) => {
  //states
  const [activeTab, setActiveTab] = useState("overview");
  const [apiCall, setApiCall] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [nwPropertyData, setNwPropertyData] = useState(null);
  const [encryptedText, setEncryptedText] = useState(null);
  const [contactsData, setContactsData] = useState(null);
  const [matchingPropertyData, setMatchingPropertyData] = useState(null);
  const [matchingLeadsData, setMatchingLeadsData] = useState(null);
  const [popup, setPopup] = useState(null);
  const [reload, setReload] = useState(false);
  const [filter, setFilter] = useState([]);
  const [allDocument, setAllDocument] = useState([]);
  const [mapInstance, setMapInstance] = useState(null);
  const [marker, setMarker] = useState(null);
  const [documentsData, setDocumentsData] = useState({
    images: [], videos: [], documents: []
  });
  const [locationError, setLocationError] = useState('');
  const [isLocationFound, setIsLocationFound] = useState(false);

  //variables
  const models = reactLocalStorage.getObject(Const.Model);
  const model = models.property;

  const properyId = parseInt(props.match.params.propertyId);
  const user = reactLocalStorage.getObject(Const.LoggedInUser);
  let base = props.match.path;
  base = base.substring(0, base.indexOf('/preview'));

  // permisions
  const isUpdate = Util.isAllow(model.permission, Const.PermUpdate);
  const isDelete = Util.isAllow(model.permission, Const.PermDelete);
  //const ContactList = Util.isAllow(models.contact.permission, Const.PermView);
  const ContactAdd = Util.isAllow(models.contact.permission, Const.PermAdd);
  const ContactUpdate = Util.isAllow(models.contact.permission, Const.PermUpdate);
  const ContactDelete = Util.isAllow(models.contact.permission, Const.PermDelete);
  const docFormats = Const.FileType;
  //const DocList = Util.isAllow(models.document.permission, Const.PermView);
  const DocAdd = Util.isAllow(models.document.permission, Const.PermAdd);
  const DocDelete = Util.isAllow(models.document.permission, Const.PermDelete);
  const HideAllContact = Util.isAllow(models.property.permission, Const.HideAllContact);
  const HideOthersContact = Util.isAllow(models.property.permission, Const.HideOtherContact);
  
  let HideOtherContactView = false;

  useEffect(() => {
    setApiCall(true);
    PropertyAPI.get(properyId, onReceived, props.failure, props.logout);
    getEncryptedKey();
  }, []);
  useEffect(() => {
    if (reload === true) {
      updateMater();
    }
  }, [reload]);

  const getEncryptedKey = async () => {
    const encryptedText = Util.generateShortId(user.client_id, properyId);
    setEncryptedText(encryptedText);
  };

useEffect(() => {
  if (!nwPropertyData) return;
  let map;
  const initMap = async () => {
    try {
      await loadGoogleMaps();

      const clean = v => v?.replace(/~/g, '').trim();

      const street = clean(nwPropertyData.address_street);
      const cityId = clean(nwPropertyData.address_city);
      const stateId = clean(nwPropertyData.address_state);

      if (!street) {
        setLocationError('No location added. Address is required.');
        return;
      }

      const cityObj = FieldCity.getCityById(cityId);
      if (!cityObj?.label) {
        setLocationError('No location added. City is missing or invalid.');
        return;
      }

      const stateObj = FieldState.getStateById(stateId);
      if (!stateObj?.label) {
        setLocationError('No location added. State is missing or invalid.');
        return;
      }

      const fullAddress = `${street}, ${cityObj.label}, ${stateObj.label}, India`;
      setLocationError('');

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: fullAddress }, (results, status) => {
        if (status !== 'OK' || !results?.[0]) {
          setLocationError('Location not found. Please enter a valid address.');
          return;
        }

        const mapContainer = document.getElementById('location-map-container');
        if (!mapContainer) return;

        const loc = results[0].geometry.location;

        map = L.map('location-map-container').setView(
          [loc.lat(), loc.lng()],
          15
        );

        L.tileLayer(
          'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
          { maxZoom: 20, subdomains: ['mt0', 'mt1', 'mt2', 'mt3'] }
        ).addTo(map);

        L.marker([loc.lat(), loc.lng()]).addTo(map);
        setMapInstance(map);
      });

    } catch (err) {
      console.error(err);
      setLocationError('Failed to load map.');
    }
  };
  initMap();
  return () => {
    if (map) map.remove();
  };
}, [nwPropertyData]);

  const onDocumentReceived = (res) => {
    setAllDocument(res);
    let images = [], videos = [], documents = [], videoLinks = [];
    res.data.filter((d) => d.status === 1).forEach((item) => {
      if (item.link !== '' && item.link !== null) {
        videoLinks.push(item.link);
      }
      item.images.forEach((image) => {
        if (Const.FileUploadType[0].includes(image.file_type)) {
          images.push(image);
        } else if (Const.FileUploadType[1].includes(image.file_type)) {
          videos.push(image);
        } else if (Const.FileUploadType[2].includes(image.file_type)) {
          documents.push(image);
        }
      });
    });
    setDocumentsData({ images, videos, documents });
  };

  const onContactReceived = (res) => {
    setContactsData(res.data);
  };

  const onReceived = async (res) => {
    const featuredImage = res?.featured_image ? await DocumentAPI.getPublicMediaUrl(res?.featured_image?.split(Const.Opt)?.filter(Boolean)) : { url: "/images/dummyProperty.jpg", };
    const data = { ...res, featured_image: featuredImage?.url };
    setNwPropertyData(data);
  
    if (HideOthersContact) {
      if (res.responsible_person && !res.responsible_person.includes('~' + user.user_id + '~')) {
        HideOtherContactView = true;
      }
    }
    DocumentAPI.getInnerList(Const.Property, properyId, onDocumentReceived, props.onFailure);
    ContactAPI.getPropertyContactList(properyId, onContactReceived, props.onFailure);
    onProperties(res);
    onMatchingLeads(res);
    setApiCall(false);
  };

  const onDelete = () => Util.confirmAlert('Delete', `Are you sure you want to delete`
    , 'Delete', 'No', () => {
      setApiCall(true);
      PropertyAPI.delete(properyId, onDeleteSuccess,
        props.onFailure, () => { });
    });

  const onDocumentDelete = (documentId) => {
    Util.confirmAlert(
      "Delete",
      "Are you sure you want to delete",
      "Delete",
      "No",
      () => {
        setApiCall(true);
        DocumentAPI.delete(
          documentId,
          onDocumentDeleteSuccess,
          () => setApiCall(false)
        );
      }
    );
  };

  const onDocumentDeleteSuccess = () => {
    Util.showNotification('Successful', 'Document deleted successfully', 'success');
    updateMater();
  };

  const onContactDeleteSuccess = () => {
    Util.showNotification('Successful', 'Owner Details deleted successfully', 'success');
    updateMater();
  };

  const onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Property deleted successfully', 'success');
    props.navigate('/property');
  };

  const updateMater = () => {
    setApiCall(true);
    PropertyAPI.get(properyId, onReceived, props.failure, () => { });
    setPopup(null);
    setReload(false);
  };

  const redirectAddContact = id => props.navigate(`/contact/add-edit/${id}`);

  const addContact = contact => {
    setApiCall(true);
    setPopup(null);
    PropertyAPI.addContact(properyId, contact,
      (res) => {
        onReceived(res);
        Util.showNotification('Successful', 'Owner Details created successfully', 'success');
      },
      () => setApiCall(false)
    );
  };

  const sefUrl = `${user.custom_domain || 'www.orggenproperties.com'}/en/property?${encryptedText + '?' + user.client_id}`;
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(sefUrl)}`;

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Link copied to clipboard!");
  };

  const renderStars = (rating) => {
    const stars = Number.parseInt(rating);
    return (
      <div className="d-flex">
        {[1, 2, 3, 4, 5].map((star) => (
          <FaStar key={star} className={`mr-1 ${star <= stars ? "text-warning" : "text-secondary"} `} size={14} />
        ))}
      </div>
    );
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
    setIsImageModalOpen(true);
  };

  const handleSelectImageChange = (e) => {
    const value = e.target.value;
    const index = documentsData.images.indexOf(value);
    if (index !== -1) {
      setSelectedImageIndex(index);
    }
  };
  const showDetails = (model, field) => {
    if (field === 'sales-order') {
      props.navigate(`/sales-order/preview/${model}`);
      return;
    } else if (field === 'contact') {
      props.navigate(`/contact/preview/${model}`);
      return;
    }
  };
  const handlePreviousImage = () => {
    setSelectedImageIndex((prevIndex) => Math.max(0, prevIndex - 1));
  };

  const handleNextImage = () => {
    setSelectedImageIndex((prevIndex) => Math.min(documentsData.images.length - 1, prevIndex + 1));
  };

  const onProperties = (res) => {
    const fields = model.fields;
    if (!!res.property_transaction) filter.push({
      field: 'property_transaction', type: fields['property_transaction'].field_type,
      condition: 'in', value: `${res.property_transaction}`
    });
    if (!!res.property_status) filter.push({
      field: 'property_status', type: fields['property_status'].field_type,
      condition: 'in', value: `${res.property_status}`
    });
    if (!!res.property_type) filter.push({
      field: 'property_type', type: fields['property_type'].field_type,
      condition: 'in', value: `${res.property_type}`
    });
    PropertyAPI.list({ filters: filter, pagination: { currentPage: 1, perPage: 100 } }, (res) => { setMatchingPropertyData(res.data); }, props.Failure);
  };

  const onMatchingLeads = (res) => {
    let updatedFilter = [];

    const fields = models.lead.fields;
    const SearchLead = reactLocalStorage.getObject(LeadConst.SearchLead);
    for (let i = 0; i < SearchLead.length; i++) {
      const field = SearchLead[i];
      if (!fields[field]) {
        continue;
      }
      const type = fields[field].field_type;
      if ((type === Const.Number || type === Const.Decimal)) {
        if (field === LeadConst.MinBudget && res.price) {
          // updatedFilter.push({ field, type, condition: 'start-with', value: `${res.price}~` });
        } else if (res[field]) {
          // updatedFilter.push({ field, type, condition: 'start-with', value: `${res[field]}~` });
        }
      } else if (type.includes(Const.Select) && res[field]) {
        const value = typeof res[field] === 'string' && res[field].includes(Const.Opt)
          ? res[field] : `~${res[field]}~`;
        updatedFilter.push({ field, type, condition: 'in', value });
      }
    }
    setFilter(updatedFilter);
    LeadAPI.list({ filters: updatedFilter, pagination: { currentPage: 1, perPage: 100 } }, (res) => { setMatchingLeadsData(res); }, props.Failure);
  };

 const PropertyDetails = (nwPropertyData, model) => {
  const existingFieldKeys = ['property_type', 'property_transaction', 'deposit', 'type', 'possession_type', 'transaction_type'];
  const additionalInformation = Object.values(model.fields || {})
    .filter(field => (field.editable == 1 || field.visible == 1) && !existingFieldKeys?.includes(field?.field_key))
    .map(field => ({
      label: field.label_name,
      value: Display.FieldValue(nwPropertyData, field.field_key, model.fields)
    }));
  return <>
    <div className="p-4 rounded-3 bg-light mb-4">
      <h6 className="font-weight-semibold h6 mb-3">Additional Information</h6>
      <Row className="mb-3">
        {additionalInformation.map((item, idx) => {
          return <Col xs={6} md={3} key={idx} className="mb-3">
            <span className="small text-secondary">{item?.label}:</span>
            <p className="font-weight-medium text-dark mb-0">{item?.value || '-'}</p>
          </Col>;
        })}
      </Row>
    </div>

    {/* Amenities Section */}
    <div className="p-4 rounded-3 bg-light mb-4">
      <h6 className="font-weight-semibold h6 mb-3">Amenities</h6>
      <Row className="mb-3">
        {Amenities(nwPropertyData, model)}
      </Row>
    </div>

    {/* Google Maps Section */}
    <div className="p-4 rounded-3 bg-light mb-4">
      <h6 className="font-weight-semibold mb-3">Property Location</h6>
      {locationError ? (
        <div className="d-flex flex-column align-items-center justify-content-center text-center p-5 rounded-3 border border-light"
             style={{ height: '400px', background: 'linear-gradient(to bottom right, #f8fafc, #e2e8f0)' }}>
          <div className="mb-4">
            <div className="d-flex align-items-center justify-content-center mx-auto mb-3 rounded-circle bg-white shadow-sm"
                 style={{ width: "5rem", height: "5rem" }}>
              <FaMapMarkerAlt size={28} className="text-danger" />
            </div>
          </div>
          <h6 className="font-weight-semibold text-dark mb-2">Location Not Available</h6>
          <p className="text-muted mb-0" style={{ maxWidth: '400px' }}>
            {locationError}
          </p>
          <div className="mt-3 small text-secondary">
            <div className="d-flex align-items-center justify-content-center">
              <FaMapMarkerAlt className="mr-2" size={14} />
              <span>Address: {nwPropertyData?.address_street || 'Not specified'}</span>
            </div>
          </div>
        </div>
      ) : (
        <div id="location-map-container" className="w-100 rounded-3 overflow-hidden shadow-sm" 
             style={{ height: '400px', width: '100%' }}>
        </div>
      )}
    </div>

    {/* Related Properties Slider */}
    <div className="p-4 rounded-3 bg-light">
      <h6 className="font-weight-semibold h6 mb-3">Similar Properties</h6>
      <div className="d-flex overflow-auto pb-2" style={{ gap: "0.75rem" }}>
        <RelatedPropertiesList
          matchingPropertyData={matchingPropertyData}
          model={model}
          nwPropertyData={nwPropertyData}
          navigate={props.navigate}
        />
      </div>
    </div>
  </>;
};

  const showPopUp = (model, field) => {
    setPopup(field);
  };

  const hidePopUp = () => setPopup('refresh');
  const PropertyContactPopUp = ContactAdd ?
    <PropertyContactPopup show={popup === 'contact'} onHide={() => hidePopUp()}
      redirect={redirectAddContact} addContact={addContact} model_id={properyId}
      model_no={Const.Property} reload={() => { setReload(true); }} />
    : null;
  const ImagePopUp = DocAdd ?
    <DocumentPopup show={popup === 'image'} onHide={() => hidePopUp()}
      reload={() => { setReload(true); }} model_no={Const.Property}
      model_id={properyId} title="Add Image" document_type={docFormats[0]} /> : null;
  const VideoPopUp = DocAdd ?
    <DocumentPopup show={popup === 'video'} onHide={() => hidePopUp()}
      reload={() => { setReload(true); }} model_no={Const.Property}
      model_id={properyId} title="Add Video" document_type={docFormats[1]} /> : null;
  const DocumentPopUp = DocAdd ?
    <DocumentPopup show={popup === 'document'} onHide={() => hidePopUp()}
      reload={() => { setReload(true); }} model_no={Const.Property}
      model_id={properyId} title="Add Document" document_type={docFormats[2]} /> : null;
  const whatsappPopup = <WhatsAppPopup show={popup === 'whats-app'} onHide={() => hidePopUp()}
    data={nwPropertyData} model={model} />;

  const handleFacebookShare = () => {
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(sefUrl)}`;
    window.open(facebookShareUrl, "_blank", "noopener,noreferrer");
  };
  const handleWhatsAppShare = () => {
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(sefUrl)}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };
  const handleEmailShare = () => {
    const subject = "Check this out!";
    const body = `I thought you might like this: ${sefUrl}`;
    const emailUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = emailUrl;
  };
  const handleInstagramOpen = () => {
    const instagramProfileUrl = "https://www.instagram.com/yourprofile/";
    window.open(instagramProfileUrl, "_blank", "noopener,noreferrer");
  };
  const handleTwitterShare = () => {
    const text = "Check this out!" + sefUrl;
    const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(sefUrl)}&text=${encodeURIComponent(text)}`;
    window.open(twitterUrl, "_blank", "noopener,noreferrer");
  };
  //Delete
  const handleDeleteImage = (index) => {
    const imageId = documentsData?.images[index].id;
    const data = allDocument.data.find((doc) =>
      doc.images.some((img) => img.id === imageId)
    );
    if (!data?.id) return;

    // Call your API
    DocumentAPI.delete(
      data.id,
      () => {
        const updatedImages = documentsData.images.filter((_, i) => i !== index);
        setDocumentsData({ ...documentsData, images: updatedImages });
        setIsImageModalOpen(false);
      },
      (error) => {
        console.error("Error deleting image:", error);
        alert("Failed to delete image");
      }
    );
  };

  return (
    <>
      {PropertyContactPopUp} {DocumentPopUp} {ImagePopUp} {VideoPopUp}{whatsappPopup}
      <div style={{ background: "linear-gradient(to bottom right, #f8fafc, #e0f2fe)" }} className="min-vh-100">
        {/* Header */}
        <div style={{ background: "linear-gradient(to right, #475569, #1e293b)" }} className="text-white shadow-lg">
          <Container fluid className="py-4 px-4 px-sm-4 px-lg-5" style={{ paddingLeft: 0, paddingRight: 0, }}>
            <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between">
              <div className="d-flex align-items-center mb-3 mb-lg-0">
                <div
                  className="d-flex align-items-center justify-content-center mr-3 rounded-3"
                  style={{
                    width: "4rem",
                    height: "4rem",
                    backgroundColor: "rgba(255,255,255,0.1)",
                    backdropFilter: "blur(4px)",
                  }}
                >
                  <FaHome size={24} className="text-white" />
                </div>
                <div>
                  <h1 className="h2 font-weight-bold mb-1">{nwPropertyData?.name}</h1>
                  <div className="d-flex flex-wrap" style={{ gap: "0.75rem" }}>
                    {" "}
                    {/* Replaced gap-3 with inline style */}
                    <span className="d-flex align-items-center small text-light">
                      <FaBuilding className="mr-1" size={14} />
                      {nwPropertyData?.property_id || '-'}
                    </span>
                    <span className="d-flex align-items-center small text-light">
                      <FaMapMarkerAlt className="mr-1" size={14} />
                      {Display.FieldValue(nwPropertyData, 'type', model.fields)}
                    </span>
                    <div className="d-flex align-items-center">
                      {renderStars(nwPropertyData?.rating) || null}
                      <span className="ml-2 small">{nwPropertyData?.rating || '-'}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-wrap justify-content-end" style={{ gap: "0.5rem" }}>
                {/* Design Selection */}
                <Dropdown className="d-inline-block ms-2">
                  <Dropdown.Toggle variant="secondary" size="md" id="design-dropdown">
                    Design {props.designView}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => props.setDesign('1')}>Design 1</Dropdown.Item>
                    <Dropdown.Item onClick={() => props.setDesign('2')}>Design 2</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                {/* Owner Details */}
                {(HideAllContact || HideOtherContactView) ? null : (ContactAdd ? (
                  <Button
                    variant="info"
                    onClick={() => showPopUp(null, 'contact')}
                  >
                    <FaUser className="mr-1" size={14} />
                    Owner Details
                  </Button>
                ) : null)}

                {/* Update */}
                {isUpdate && (
                  <NavLink to={`${base}/add-edit/${properyId}`}>
                    <Button variant="warning">
                      <FaEdit className="mr-1" size={14} />
                      Update
                    </Button>
                  </NavLink>
                )}

                {/* Delete */}
                {isDelete && (
                  <Button variant="danger" onClick={onDelete}>
                    <FaTrash className="mr-1" size={14} />
                    Delete
                  </Button>
                )}

                {/* Dropdown: More Actions */}
                <Dropdown className="d-inline-block">
                  <Dropdown.Toggle variant="primary">
                    More
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => showPopUp(null, 'image')}>
                      <FaUpload className="me-2 text-primary" /> Image Upload
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => showPopUp(null, 'video')}>
                      <FaVideo className="me-2 text-danger" /> Video Upload
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => showPopUp(null, 'document')}>
                      <FaFile className="me-2 text-success" /> Document Upload
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => showPopUp({}, 'whats-app')}>
                      <FaWhatsapp className="me-2 text-success" /> WhatsApp
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </Container>
        </div >

        <Container fluid className="py-4 px-4 px-sm-4 px-lg-5">
          <Row className="mb-4">
            {" "}
            {/* Removed g-4 */}
            {/* Main Content */}
            <Col xl={9} className="mb-4">
              {/* Stats Cards */}
              <Row className="mb-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-5">

                {" "}
                <Col className="mb-3">

                  {" "}
                  {/* Added mb-3 for spacing */}
                  <Card
                    className="border-0 shadow-sm h-100"
                    style={{ background: "linear-gradient(to bottom right, #f0fdf4, #dcfce7)" }}
                  >
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <div style={{ cursor: 'pointer' }} onClick={() => { props.navigate(`/lead?filters=${JSON.stringify(filter)}`); }}>
                          <p className="font-weight-medium text-success mb-1">Matching Leads</p>
                          <p className="font-weight-bold text-success mb-0 text-wrap"
  style={{ fontSize: "clamp(1rem, 1.5vw, 2rem)" }}>
                            {matchingLeadsData?.count}
                          </p>
                        </div>
                        <FaFile size={32} className="text-success" />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                {/* Removed g-3 */}
                <Col className="mb-3">

                  {" "}
                  {/* Added mb-3 for spacing */}
                  <Card
                    className="border-0 shadow-sm h-100"
                    style={{ background: "linear-gradient(to bottom right, #f0fdf4, #dcfce7)" }}
                  >
                    <Card.Body className="p-4">
                   <div className="d-flex align-items-center justify-content-between flex-wrap">
                      <div className="w-100">
                        <p className="font-weight-medium text-success mb-1">Total Price</p>
                        <p
                          className="font-weight-bold text-success mb-0 text-wrap"
                          style={{
                            fontSize: "clamp(0.5rem, 1vw, 1.5rem)",
                            whiteSpace: "nowrap"
                          }}
                                                >
                          {Util.formatINRCurrency(nwPropertyData?.price)}
                        </p>
                      </div>
                    </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="mb-3">

                  {" "}
                  {/* Added mb-3 for spacing */}
                  <Card
                    className="border-0 shadow-sm h-100"
                    style={{ background: "linear-gradient(to bottom right, #eff6ff, #dbeafe)" }}
                  >
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p className="font-weight-medium text-primary mb-1">{model?.fields['build_area']?.label_name}</p>
                          <p className="h4 font-weight-bold text-primary mb-0">{nwPropertyData?.build_area}</p>
                        </div>
                        <FaBuilding size={32} className="text-primary" />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="mb-3">

                  {" "}
                  {/* Added mb-3 for spacing */}
                  <Card
                    className="border-0 shadow-sm h-100"
                    style={{ background: "linear-gradient(to bottom right, #f5f3ff, #ede9fe)" }}
                  >
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p className="font-weight-medium text-purple mb-1">{model?.fields['price_per_sqft']?.label_name}</p>
                          <p className="h4 font-weight-bold text-purple mb-0">{Util.formatINRCurrency(nwPropertyData?.price_per_sqft)}</p>
                        </div>
                        <FaHome size={32} className="text-purple" />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col className="mb-3">

                  {" "}
                  {/* Added mb-3 for spacing */}
                  <Card
                    className="border-0 shadow-sm h-100"
                    style={{ background: "linear-gradient(to bottom right, #fffbeb, #fef3c7)" }}
                  >
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p className="font-weight-medium text-warning mb-1">Status</p>
                          <span className="badge badge-success">{Display.FieldValue(nwPropertyData, 'property_status', model.fields)}</span>{" "}
                          {/* Changed bg-success-subtle to badge-success */}
                        </div>
                        <FaCalendarAlt size={32} className="text-warning" />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* Main Content Card */}
              <Card
                className="border-0 shadow-lg"
                style={{ backgroundColor: "rgba(255,255,255,0.8)", backdropFilter: "blur(4px)" }}
              >
                <Card.Body className="p-0">
                  {/* Tab Navigation */}
                  {/* <Nav variant="tabs" className="border-bottom border-light bg-light"> */}
                  <ul className="nav nav-tabs border-0" style={{ backgroundColor: '#f1f5f9' }}>
                    {['overview', 'images', 'documents', 'videos', 'owners'].map(tab => (
                      <li className="nav-item flex-fill" key={tab}>
                        <button
                          className={`nav-link text-center w-100 border-0 ${activeTab === tab ? 'active bg-white' : ''}`}
                          onClick={() => setActiveTab(tab)}
                          style={{
                            textTransform: 'capitalize',
                            color: activeTab === tab ? '#1e293b' : '#64748b'
                          }}
                        >
                          {tab}
                        </button>
                      </li>
                    ))}
                  </ul>
                  {/* </Nav> */}

                  {/* Tab Content */}
                  <div className="p-4">
                    {activeTab === "overview" && (
                      <div>
                        <Row className="mb-4">
                          {" "}
                          {/* Removed g-6 */}
                          {/* Featured Image */}
                          <Col lg={6} className="mb-4 mb-lg-0">
                            {" "}
                            {/* Added mb-4 for mobile spacing */}
                            {/* <h5 className="font-weight-semibold h5 mb-3">Featured Image</h5> */}
                            <div
                              className="embed-responsive embed-responsive-16by9 overflow-hidden rounded-lg shadow-sm"
                              style={{ background: "linear-gradient(to bottom right, #f1f5f9, #e2e8f0)" }}
                            >
                              <img
                                src={nwPropertyData?.featured_image}
                                alt="Property Featured"
                                className="embed-responsive-item w-100 h-100 object-fit-cover rounded-lg" // Added embed-responsive-item
                                style={{ transition: "transform 0.3s ease" }}
                                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                              />
                            </div>
                          </Col>
                          {/* Property Details */}
                          <Col lg={6}>
                            <h5 className="font-weight-semibold h5 mb-3">Property Details</h5>
                            <Row className="mb-3">
                              {" "}
                              {/* Removed g-3 */}
                              {[
                                { label: model.fields['property_type']?.label_name, value: Display.FieldValue(nwPropertyData, 'property_type', model.fields) },
                                { label: model.fields['type']?.label_name, value: Display.FieldValue(nwPropertyData, 'type', model.fields) },
                                { label: model.fields['transaction_type']?.label_name, value: Display.FieldValue(nwPropertyData, 'transaction_type', model.fields) },
                                { label: model.fields['property_transaction']?.label_name, value: Display.FieldValue(nwPropertyData, 'property_transaction', model.fields) },
                                { label: model.fields['possession_type']?.label_name, value: Display.FieldValue(nwPropertyData, 'possession_type', model.fields) },
                                { label: model.fields['deposit']?.label_name, value: `₹${Number.parseInt(nwPropertyData?.deposit).toLocaleString()} ` },
                              ].map((item, idx) => (
                                <Col xs={6} key={idx} className="mb-3">
                                  {" "}
                                  {/* Added mb-3 for spacing */}
                                  <div className="p-3 rounded-3 bg-light">
                                    <label className="small font-weight-medium text-uppercase text-secondary mb-1">
                                      {item.label}
                                    </label>
                                    <p className="font-weight-semibold text-dark mb-0">{item.value || '-'}</p>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          </Col>
                        </Row>
                        {PropertyDetails(nwPropertyData, model)}
                      </div>
                    )}

                    {activeTab === "images" && (
                      <>
                        <Row className="mb-3">
                          {documentsData && documentsData?.images.length > 0 ? documentsData?.images.map((img, idx) => (
                            <Col xs={6} sm={4} md={3} lg={2} key={idx} className="mb-3">
                              {" "}
                              {/* Added mb-3 for spacing */}
                              <div
                                className="position-relative w-100 embed-responsive embed-responsive-1by1 overflow-hidden rounded-lg shadow-sm cursor-pointer "
                                onClick={() => handleImageClick(idx)}
                              >
                                <img
                                  src={img.url || "/placeholder.svg"}
                                  alt={`Property Image ${idx + 1} `}
                                  className="embed-responsive-item w-100 h-100 object-fit-cover rounded-lg"
                                  style={{ transition: "transform 0.3s ease" }}
                                  onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                                  onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                                />

                              </div>
                            </Col>
                          )) :
                            <> <div className="text-center py-5 m-auto">
                              <div
                                className="d-flex align-items-center justify-content-center mx-auto mb-3 rounded-circle bg-light"
                                style={{ width: "5rem", height: "5rem" }}
                              >
                                <FaImage size={40} className="text-muted" />
                              </div>
                              <h5 className="font-weight-semibold h5 mb-2 text-secondary">No Images Yet</h5>
                              <p className="text-muted mb-4">Upload Images to showcase this property</p>
                            </div></>}
                          <Modal show={isImageModalOpen} onHide={() => setIsImageModalOpen(false)} size="xl" centered>
                            <Modal.Body className="p-4">
                              <div className="d-flex flex-column align-items-center">
                                <div
                                  className="d-flex align-items-center justify-content-center mb-4"
                                  style={{ gap: "0.5rem" }}
                                >
                                  {" "}
                                  {/* Replaced gap-2 with inline style */}
                                  <Button
                                    variant="outline-secondary"
                                    onClick={handlePreviousImage}
                                    disabled={selectedImageIndex === 0}
                                  >
                                    Previous
                                  </Button>
                                  <Form.Control
                                    as="select" // Use as="select" for Form.Select in React Bootstrap 1.x
                                    className="w-auto"
                                    style={{ minWidth: "280px" }}
                                    onChange={handleSelectImageChange}
                                    value={documentsData.images[selectedImageIndex]}
                                  >
                                    {documentsData.images.map((img, i) => (
                                      <option key={i} value={img}>
                                        {"Image " + (i + 1)}
                                      </option>
                                    ))}
                                  </Form.Control>
                                  <Button
                                    variant="outline-secondary"
                                    onClick={handleNextImage}
                                    disabled={selectedImageIndex === documentsData.images.length.length - 1}
                                  >
                                    Next
                                  </Button>
                                </div>
                                <div className="w-100 overflow-hidden rounded-3" style={{}}>
                                  <img
                                    src={documentsData.images[selectedImageIndex]?.url || "/placeholder.svg"}
                                    alt="Selected Property Image"
                                    className="img-fluid w-50 h-50 object-fit-contain "
                                    style={{ transition: "transform 0.3s ease" }}
                                    onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                                    onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                                  />
                                </div>
                                {DocDelete ? (
                                  <Button
                                    variant="danger"
                                    className="mt-4 d-flex align-items-center gap-2"
                                    onClick={() => handleDeleteImage(selectedImageIndex)}
                                  >
                                    <FaTrash />
                                    Delete
                                  </Button>
                                ) : null}
                              </div>
                            </Modal.Body>
                          </Modal>
                        </Row>
                        {PropertyDetails(nwPropertyData, model)}
                      </>
                    )}

                  {activeTab === "documents" && (
                      <>
                        <div className="overflow-auto">
                          <table className="table w-100">
                            <thead className="bg-light">
                              <tr>
                                <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">File Name</th>
                                <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">
                                  File Type
                                </th>
                                <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">
                                  Created Date
                                </th>
                                <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">
                                  Created By
                                </th>
                                <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {documentsData && documentsData.documents.length > 0 ? documentsData.documents.map((doc, idx) => {
                                const parentDocument = allDocument.data.find((document) =>
                                  document.images.some((file) => file.id === doc.id)
                                );
                                return (
                                  <tr key={idx}>
                                    <td className="px-4 py-3 font-weight-medium text-dark">{doc.name}</td>
                                    <td className="px-4 py-3 text-secondary">{doc?.file_type}</td>
                                    <td className="px-4 py-3 text-secondary">{Util.dateToDisplayDateTime(doc?.created_date)}</td>
                                    <td className="px-4 py-3 text-secondary">{Display.FieldValue(doc, 'created_by', models?.document?.fields)}</td>
                                    <td className="px-4 py-3">
                                      <div className="d-flex" style={{ gap: "0.5rem" }}>
                                        <Button
                                          variant="outline-success" 
                                          size="sm"
                                          href={doc?.url}
                                          target="_blank"
                                        >
                                          <FaDownload /> Download
                                        </Button>
                                      {DocDelete && parentDocument?.id ? (
                                        <Button
                                          variant="outline-danger"
                                          size="sm"
                                          onClick={() => onDocumentDelete(parentDocument.id)}
                                        >
                                          <FaTrash size={12} /> Delete
                                        </Button>
                                      ) : null}
                                      </div>
                                    </td>
                                  </tr>
                                );
                              }) : (
                                <tr>
                                  <td colSpan={5} className="px-4 py-3 text-center">
                                    No documents found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        {PropertyDetails(nwPropertyData, model)}
                      </>
                    )}

                    {activeTab === "videos" && (
                      <>
                        <Row className="mb-3">
                          {documentsData?.videos?.length > 0 ? (
                            documentsData.videos.map((video, idx) => (
                              <Col xs={6} sm={4} md={3} lg={2} key={idx} className="mb-3">
                                <div
                                  className="position-relative w-100 embed-responsive embed-responsive-1by1 overflow-hidden rounded-lg shadow-sm"
                                >
                                  <video
                                    src={video.url}
                                    controls
                                    className="embed-responsive-item w-100 h-100 object-fit-cover rounded-lg"
                                    style={{ objectFit: "cover", transition: "transform 0.3s ease" }}
                                  />
                                </div>
                              </Col>
                            ))
                          ) : (
                            <div className="text-center py-5 m-auto">
                              <div
                                className="d-flex align-items-center justify-content-center mx-auto mb-3 rounded-circle bg-light"
                                style={{ width: "5rem", height: "5rem" }}
                              >
                                <FaVideo size={40} className="text-muted" />
                              </div>
                              <h5 className="font-weight-semibold h5 mb-2 text-secondary">No Videos Yet</h5>
                              <p className="text-muted mb-4">Upload videos to showcase this property</p>
                            </div>
                          )}
                        </Row>

                        {PropertyDetails(nwPropertyData, model)}
                      </>
                    )}

                    {activeTab === "owners" && (
                      <>
                        {contactsData && contactsData.length > 0 ? (
                          <div className="overflow-auto">
                            <table className="table w-full">
                              <thead className="bg-light">
                                <tr>
                                  <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">Name</th>
                                  <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">Phone</th>
                                  <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">Email</th>
                                  <th className="px-4 py-2 text-left small font-weight-semibold text-secondary">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {contactsData.map((contact, idx) => (
                                  <tr key={idx}>
                                    <td className="px-4 py-3 font-weight-medium text-dark">
                                      {contact.firstname + " " + contact.lastname || '-'}
                                    </td>
                                    <td className="px-4 py-3 text-secondary">
                                      {Display.FieldValue(contact, 'phone', models.contact.fields)}
                                    </td>
                                    <td className="px-4 py-3 text-secondary">
                                      {Display.FieldValue(contact, 'email', models.contact.fields)}
                                    </td>
                                    <td className="px-4 py-3">
                                      <div className="d-flex" style={{ gap: "0.5rem" }}>
                                        <Button variant="outline-primary align-self-center" size="sm" onClick={() => showDetails(contact.id, 'contact')}>
                                          <FaEye className="mr-1" size={12} />
                                          View
                                        </Button>
                                        {!!ContactUpdate && <Button variant="outline-success align-self-center" size="sm" onClick={() => redirectAddContact(contact.id, 'contact')}>
                                          <FaDownload className="mr-1" size={12} />
                                          Edit
                                        </Button>}
                                        {/* <Button variant="outline-danger align-self-center" size="sm" onClick={() => onContactDelete(contact.id)}>
                                          <FaTrash size={12} className="mr-1" />
                                          Delete
                                        </Button> */}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="text-center py-5">
                            <div className="d-flex flex-column align-items-center justify-content-center">
                              <div
                                className="d-flex align-items-center justify-content-center mb-3 rounded-circle bg-light"
                                style={{ width: "5rem", height: "5rem" }}
                              >
                                <FaUser size={40} className="text-muted" />
                              </div>
                              <h5 className="font-weight-semibold h5 mb-2 text-secondary">No Owner Records</h5>
                            </div>
                          </div>
                        )}
                        {PropertyDetails(nwPropertyData, model)}
                      </>
                    )}

                  </div>
                </Card.Body>
              </Card>
            </Col>
            {/* Sidebar */}
            <Col xl={3}>
              <div className="d-flex flex-column" style={{ gap: "1rem" }}>
                {" "}
                {/* Share Properties */}
                <Col className="mb-4">
                  {" "}
                  {/* Added mb-4 for spacing */}
                  <Card
                    className="border-0 shadow-sm"
                    style={{ background: "linear-gradient(to bottom right, #eff6ff, #dbeafe)" }}
                  >
                    <Card.Header className="bg-transparent border-bottom-0 pb-2">
                      <Card.Title className="d-flex align-items-center text-dark h5">
                        <FaShareAlt className="mr-2 text-primary" size={18} />
                        Share Property
                      </Card.Title>
                    </Card.Header>
                    <Card.Body className="pt-4">
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        {/* QR Code Section */}
                        <div className="text-center">
                          <div className="mb-2">
                            <small className="text-muted font-weight-medium">Scan QR Code</small>
                          </div>
                          <div
                            className="p-2 rounded bg-white d-inline-block border border-light"
                            style={{ backgroundColor: "rgba(255,255,255,0.9)" }}
                          >
                            {" "}
                            {/* Adjusted bg-opacity-90 */}
                            <img
                              src={qrCodeUrl || "/placeholder.svg"}
                              alt="QR Code"
                              className="rounded"
                              style={{ maxWidth: "200px" }}
                            />
                          </div>
                        </div>
                        {/* Social Media Icons */}
                        <div className="d-flex flex-column" style={{ gap: "0.75rem" }}>
                          {" "}
                          {/* Replaced gap-3 with inline style */}
                          <Button
                            variant="outline-secondary"
                            onClick={handleFacebookShare}
                            style={{
                              width: "40px",
                              height: "40px",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(255,255,255,0.8)",
                              borderColor: "#e2e8f0",
                              color: "#0d6efd",
                            }}
                          >
                            <FaFacebookF size={20} />
                            <span className="sr-only">Share on Facebook</span>
                          </Button>
                          <Button
                            variant="outline-secondary"
                            onClick={handleInstagramOpen}
                            style={{
                              width: "40px",
                              height: "40px",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(255,255,255,0.8)",
                              borderColor: "#e2e8f0",
                              color: "#e83e8c",
                            }}
                          >
                            <FaInstagram size={20} />
                            <span className="sr-only">Share on Instagram</span>
                          </Button>
                          <Button
                            variant="outline-secondary"
                            onClick={handleTwitterShare}
                            style={{
                              width: "40px",
                              height: "40px",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(255,255,255,0.8)",
                              borderColor: "#e2e8f0",
                              color: "#17a2b8",
                            }}
                          >
                            <FaTwitter size={20} />
                            <span className="sr-only">Share on Twitter</span>
                          </Button>
                          <Button
                            variant="outline-secondary"
                            onClick={handleWhatsAppShare}
                            style={{
                              width: "40px",
                              height: "40px",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(255,255,255,0.8)",
                              borderColor: "#e2e8f0",
                              color: "#28a745",
                            }}
                          >
                            <FaWhatsapp size={20} />
                            <span className="sr-only">Share on WhatsApp</span>
                          </Button>
                          <Button
                            variant="outline-secondary"
                            onClick={handleEmailShare}
                            style={{
                              width: "40px",
                              height: "40px",
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "rgba(255,255,255,0.8)",
                              borderColor: "#e2e8f0",
                              color: "red",
                            }}
                          >
                            <IoIosMail size={20} />
                            <span className="sr-only">Share on Email</span>
                          </Button>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="small font-weight-medium mb-2 text-secondary">Property URL</label>
                        <div className="d-flex">
                          <Form.Control
                            type="text"
                            className="flex-grow-1 px-3 py-2 rounded-left border border-light bg-white" // Changed rounded-start to rounded-left, bg-opacity-80 removed
                            style={{ backgroundColor: "rgba(255,255,255,0.8)" }}
                            value={sefUrl}
                            readOnly
                          />
                          <Button
                            className="rounded-right border border-left-0 border-light text-secondary" // Changed rounded-end to rounded-right
                            style={{ backgroundColor: "rgba(255,255,255,0.8)" }}
                            onClick={() => copyToClipboard(sefUrl)}
                          >
                            <FaCopy size={16} />
                            <span className="sr-only">Copy Link</span>
                          </Button>
                        </div>
                      </div>
                      {/* <div className="d-grid" style={{ gap: "0.5rem" }}> */}
                      {" "}
                      {/* Replaced d-grid gap-2 with inline gap */}
                      {/* <Button variant="success">
                          <FaWhatsapp className="mr-2" size={14} />
                          Share on WhatsApp
                        </Button>
                        <Button
                          variant="outline-secondary"
                          style={{ backgroundColor: "rgba(255,255,255,0.8)", borderColor: "#e2e8f0", padding: 10 }}
                        >
                          <FaShareAlt className="mr-2" size={14} />
                          Copy Link
                        </Button> */}
                      {/* </div> */}
                    </Card.Body>
                  </Card>
                </Col>
                {/* Contact Information */}
                <Col className="mb-4">
                  {" "}
                  {/* Added mb-4 for spacing */}
                  <Card
                    className="border-0 shadow-sm "
                    style={{ background: "linear-gradient(to bottom right, #f8fafc, #e2e8f0)", borderRadius: '0.5rem' }}
                  >
                    <Card.Header className="bg-transparent border-bottom-0 pb-2 ">
                      <Card.Title className="text-dark h5">Owner Information</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <div className="bg-white rounded-3 p-3 shadow-sm mb-3" style={{ borderRadius: '0.5rem' }}>
                        <div className="d-flex align-items-center mb-3 rounded-3 ">
                          <div
                            className="d-flex align-items-center justify-content-center mr-3 rounded-circle bg-light"
                            style={{ width: "2.5rem", height: "2.5rem" }}
                          >
                            <FaUser size={20} className="text-muted" />
                          </div>
                          <div>
                            <p className="font-weight-semibold text-dark mb-0">{nwPropertyData?.cont_first}</p>
                            <p className="font-weight-semibold text-dark mb-0">{nwPropertyData?.cont_phone?.split('~')?.filter(Boolean)?.join(',')}</p>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Matching Leads Information */}
                <Col className="mb-4" >
                  {" "}
                  {/* Added mb-4 for spacing */}
                  <Card
                    className="border-0 shadow-sm "
                    style={{ background: "linear-gradient(to bottom right, #f8fafc, #e2e8f0)", borderRadius: '0.5rem' }}
                  >
                    <Card.Header className="bg-transparent border-bottom-0 pb-2 ">
                      <Card.Title className="text-dark h5">Matching Leads</Card.Title>
                    </Card.Header>
                    <Card.Body>
                      {matchingLeadsData && matchingLeadsData.data.length > 0 ? (
                        matchingLeadsData.data?.map((lead) => (
                          <div
                            key={lead.id}
                            className="bg-white rounded-lg p-3 shadow-sm mb-3 lead-card transition"
                            style={{
                              borderRadius: "0.75rem",
                              cursor: "pointer",
                              borderLeft: "4px solid #4680e5ff",
                            }}
                            onClick={() => props.navigate(`/lead/preview/${lead.id}`)}
                          >
                            <div className="d-flex align-items-start">
                              {/* Icon Avatar */}
                              <div
                                className="d-flex align-items-center justify-content-center mr-3 bg-light rounded-circle"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <FaUser size={22} className="text-primary" />
                              </div>

                              {/* Lead Info */}
                              <div className="flex-grow-1">
                                <h6 className="mb-1 font-weight-bold text-dark">
                                  {Display.ModelName(lead)}
                                </h6>

                                <div className="small text-muted mb-1">
                                  <strong>{models.lead.fields['phone'].label_name}:</strong>{" "}
                                  {Display.FieldValue(lead, "phone", models.lead.fields) || "N/A"}
                                </div>

                                <div className="small text-muted mb-1">
                                  <strong>{models.lead.fields['property_type'].label_name}:</strong>{" "}
                                  {Display.FieldValue(lead, "property_type", models.lead.fields) || "N/A"}
                                </div>

                                <div className="small text-muted">
                                  <strong>{models.lead.fields['property_is'].label_name}:</strong>{" "}
                                  {Display.FieldValue(lead, "property_is", models.lead.fields) || "N/A"}
                                </div>
                              </div>
                            </div>
                          </div>

                        ))
                      ) : (
                        <p className="text-muted">No matching leads found.</p>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              </div>
            </Col>
          </Row>
        </Container>
      </div >
    </>
  );
};

export default PropertyPreviewDesign2;
